var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z",
    fill: "#F0DB4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5175 33.4269L13.5784 31.5744C14.1691 32.6214 14.7062 33.5074 15.9948 33.5074C17.23 33.5074 18.0087 33.0242 18.0087 31.1449V18.3639H21.7678V31.198C21.7678 35.0913 19.4856 36.8635 16.1559 36.8635C13.1489 36.8635 11.4034 35.3061 10.5173 33.4266M23.8095 33.0241L26.8701 31.252C27.6759 32.5678 28.7231 33.5344 30.5756 33.5344C32.1333 33.5344 33.1264 32.7556 33.1264 31.6816C33.1264 30.3928 32.1061 29.9363 30.3876 29.1847L29.4481 28.7817C26.7361 27.6274 24.937 26.1774 24.937 23.1164C24.937 20.2971 27.0851 18.1489 30.4416 18.1489C32.8312 18.1489 34.5497 18.9814 35.7847 21.1563L32.858 23.0358C32.2134 21.8813 31.5156 21.4249 30.4416 21.4249C29.3406 21.4249 28.6425 22.123 28.6425 23.0358C28.6425 24.1635 29.3406 24.62 30.9516 25.3183L31.8912 25.721C35.0864 27.0905 36.8855 28.4864 36.8855 31.6278C36.8855 35.0113 34.2273 36.8638 30.6562 36.8638C27.1658 36.8638 24.9103 35.1991 23.8095 33.0241Z",
    fill: "#323330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.1ede5db8a11529604d4708d299ac54e0.svg";
export { ForwardRef as ReactComponent };